import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpTitle } from './HelpElements';

const IntroductionHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('introductionHelp');

    return (
        <>
            <HelpTitle>{t('introductionHelp_Title')}</HelpTitle>
            <HelpBody>{t('introductionHelp_purpose')}</HelpBody>
            <HelpBody>{t('introductionHelp_contactInformation')}</HelpBody>
            <HelpBody>
                <Trans
                    i18nKey={'introductionHelp_contactAmazon'}
                    ns={'introductionHelp'}
                    components={{
                        b: <b />,
                        mailto: <Link href={'mailto:amazon-devices-returns@amazon.com'}>{''}</Link>,
                    }}
                />
            </HelpBody>
            <HelpBody>
                <Trans
                    i18nKey={'introductionHelp_contactRing'}
                    ns={'introductionHelp'}
                    components={{ b: <b />, mailto: <Link href={'mailto:ring-returns@amazon.com'}>{''}</Link> }}
                />
            </HelpBody>
        </>
    );
};

export { IntroductionHelp };
